module.exports = __webpack_public_path__ + "img/bs_sad.6e5c5501.svg";